import { ISgSdkHandler, TriggerAction } from "./types";

declare const sdkHandler: ISgSdkHandler; 

export async function loadUserData(keys: string[]): Promise<any> {
  try {
    return Promise.all(
      keys.map(restoreData)
    ).then(values => convertToObject(keys, values));
  } catch (e) {
    console.warn(e);
    return {};
  }
}

function restoreData(key: string) {
  return new Promise((resolve, reject) => {
    sdkHandler.trigger(TriggerAction.RESTORE, {
      key,
      callback: (error: unknown, result: unknown) => {
        if (error){
          reject(error);
          return;
        }
        
        resolve(result);
      },
    })
  })
    .then(tryParse);
}

function tryParse(data: any) {
  try {
    const result = JSON.parse(data);
    return result;
  } catch (error) {
    // do nothing
    return data;
  }
}

function convertToObject(keys: string[], values: any[]) {
  const result = Object.create(null);
  keys.forEach((key, index) => result[key] = values[index]);
  return result;
}
